// extracted by mini-css-extract-plugin
export default {"wrapRenderStep":"AddImage_wrapRenderStep__hSdKJ","step1":"AddImage_step1__Nfc-I","wrapImage":"AddImage_wrapImage__seSEj"};